import React, { useContext, useEffect, useState } from "react";

import { AuthContext } from "../contexts/AuthContext";
import { AdminContext } from "../contexts/AdminContext";
import { HoursContext } from "../contexts/HoursContext";
import { Link, useLocation } from "react-router-dom";

import Typography from "@material-ui/core/Typography";

import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import DashboardIcon from "@material-ui/icons/Dashboard";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ContactsIcon from "@material-ui/icons/Contacts";
import FilterDramaIcon from "@material-ui/icons/FilterDrama";
import SdStorage from "@material-ui/icons/SdStorage";
import AssessmentIcon from "@material-ui/icons/Assessment";
import EmailIcon from "@material-ui/icons/Email";
import PollIcon from "@material-ui/icons/Poll";
import HealingIcon from "@material-ui/icons/Healing";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ScheduleIcon from "@material-ui/icons/Schedule";
import BuildIcon from "@material-ui/icons/Build";

const MenuItems = ({ closeDrawer, variant = "desktop" }) => {
  const { logout, changeUser, user } = useContext(AuthContext);
  const { users, loadUsers } = useContext(AdminContext);
  const { loadHours, getHoursSummary } = useContext(HoursContext);

  const [userChanged, setUserChage] = useState(false);

  const handleUserChange = (event) => {
    if (user.username !== event.target.value) {
      var found = users.find((e) => e.username === event.target.value);
      setUserChage(true);
      changeUser(found);
    } else {
      setUserChage(false);
    }
  };

  useEffect(() => {
    if (userChanged) {
      loadHours();
      getHoursSummary();
    }
  }, [userChanged, user]);

  // Load users list when component mounts and user is super_admin
  useEffect(() => {
    if (user && user.type === "super_admin" && users.length === 0) {
      loadUsers(true); // Load active users for the dropdown
    }
  }, [user?.type, user?.id]); // Only depend on user type and id, not users array or loadUsers function

  const location = useLocation();

  const isActive = (path, startsWith = false) => {
    if (startsWith) return location.pathname.startsWith(path);
    return location.pathname === path;
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Typography variant="button" style={{ marginRight: 5 }}>
          HOLA, <b>{user.first_name}</b>!
        </Typography>
        <Typography variant="overline">({user.username})</Typography>
      </Toolbar>
      {user.type === "super_admin" && (
        <>
          <Divider />
          <Toolbar>
            <label
              style={{ display: "block", width: "100%" }}
              htmlFor={`user-select-${variant}`}
            >
              Change User:
            </label>
            <select
              id={`user-select-${variant}`}
              name={`userSelect${variant.charAt(0).toUpperCase() + variant.slice(1)}`}
              style={{ display: "block", width: "100%" }}
              value={user.username}
              autoComplete="off"
              onChange={(event) => {
                handleUserChange(event);
              }}
            >
              {users.length > 0 &&
                users.map((item, i) => {
                  return (
                    <option
                      key={i}
                      value={item.username}
                      // selected={item.username === user.username}
                    >
                      {item.username}
                    </option>
                  );
                })}
            </select>
          </Toolbar>
        </>
      )}
      <Divider />
      <List>
        {/* Generic (all employees) */}
        <ListItem button component={Link} to="/dashboard" onClick={closeDrawer} selected={isActive("/dashboard") || isActive("/") }>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem
          button
          component={Link}
          to="/manage-hours"
          onClick={closeDrawer}
          selected={isActive("/manage-hours")}
        >
          <ListItemIcon>
            <QueryBuilderIcon />
          </ListItemIcon>
          <ListItemText primary="Manage Hours" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem
          button
          component={Link}
          to="/search-hours"
          onClick={closeDrawer}
          selected={isActive("/search-hours")}
        >
          <ListItemIcon>
            <FindInPageIcon />
          </ListItemIcon>
          <ListItemText primary="Search Hours" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem button component={Link} to="/clients" onClick={closeDrawer} selected={isActive("/clients") }>
          <ListItemIcon>
            <ContactsIcon />
          </ListItemIcon>
          <ListItemText primary="Clients" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem button component={Link} to="/inventory" onClick={closeDrawer} selected={isActive("/inventory") }>
          <ListItemIcon>
            <SdStorage />
          </ListItemIcon>
          <ListItemText primary="Inventory" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem button component={Link} to="/maintenance/tasks" onClick={closeDrawer} selected={isActive("/maintenance/tasks", true)}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="My Maintenance Tasks" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem button component={Link} to="/maintenance/schedules" onClick={closeDrawer} selected={isActive("/maintenance/schedules", true)}>
          <ListItemIcon>
            <ScheduleIcon />
          </ListItemIcon>
          <ListItemText primary="Maintenance Schedules" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        <ListItem button component={Link} to="/maintenance/assets" onClick={closeDrawer} selected={isActive("/maintenance/assets", true)}>
          <ListItemIcon>
            <BuildIcon />
          </ListItemIcon>
          <ListItemText primary="Manage Assets" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>

        {/* Admin (super_admin only) */}
        <Divider style={{ marginTop: 8, marginBottom: 4 }} />
        <Typography variant="caption" style={{ padding: '4px 16px', opacity: 0.7 }}>Admin</Typography>
        {user.type === "super_admin" && (
          <>
            <ListItem button component={Link} to="/maintenance/jobs" onClick={closeDrawer} selected={isActive("/maintenance/jobs", true)}>
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText primary="All Maintenance Jobs" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/digitalocean"
              onClick={closeDrawer}
              selected={isActive("/digitalocean")}
            >
              <ListItemIcon>
                <FilterDramaIcon />
              </ListItemIcon>
              <ListItemText primary="DigitalOcean" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>

            <ListItem button component={Link} to="/manage-clients" onClick={closeDrawer} selected={isActive("/manage-clients") }>
              <ListItemIcon>
                <ContactsIcon />
              </ListItemIcon>
              <ListItemText primary="Manage Clients" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>

            <ListItem button component={Link} to="/billing-reports" onClick={closeDrawer} selected={isActive("/billing-reports") }>
              <ListItemIcon>
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText primary="Billing & Reports" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>

            <ListItem button component={Link} to="/email-campaigns" onClick={closeDrawer} selected={isActive("/email-campaigns", true)}>
              <ListItemIcon>
                <EmailIcon />
              </ListItemIcon>
              <ListItemText primary="Email Campaigns" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>


            <ListItem button component={Link} to="/data-pulse" onClick={closeDrawer} selected={isActive("/data-pulse", true)}>
              <ListItemIcon>
                <PollIcon />
              </ListItemIcon>
              <ListItemText primary="DataPulse" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>

            <ListItem button component={Link} to="/system-health" onClick={closeDrawer} selected={isActive("/system-health") }>
              <ListItemIcon>
                <HealingIcon />
              </ListItemIcon>
              <ListItemText primary="System Health" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>

            <ListItem button component={Link} to="/users" onClick={closeDrawer} selected={isActive("/users") }>
              <ListItemIcon>
                <PeopleAltIcon />
              </ListItemIcon>
              <ListItemText primary="Manage Users" primaryTypographyProps={{ noWrap: true }} />
            </ListItem>
          </>
        )}
      </List>

      <Divider />

      <List>
        <ListItem
          button
          component={Link}
          to="/my-settings"
          onClick={closeDrawer}
          selected={isActive("/my-settings")}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="My Settings" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>
        <ListItem button onClick={logout}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" primaryTypographyProps={{ noWrap: true }} />
        </ListItem>
      </List>
    </React.Fragment>
  );
};

export default MenuItems;
